const context = require.context('./', true, /\.svg$/);

export default context.keys().reduce((accumulator, filePath) => {
  const fileName = filePath.replace(/^.+\/([^/]+)\.svg/, '$1');
  const fileNameFormat = fileName.replace(/^[^_]+(_)/, ''); // Specific to Icons supplied by Belong
  accumulator[fileNameFormat] = context(filePath);
  return accumulator;
}, {});
